import React from 'react';
import { Box } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

import useStyles from './styles';

const Loading = () => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box className="btn-icon-right-wrapper" px={1}>
        <Skeleton variant="circle" width={24} height={24} />
      </Box>
      <Box className="text-title-container">
        <Skeleton variant="text" width="50%" />
      </Box>
      <Box className="pagination" mr={1}>
        <Skeleton variant="text" width="60px" />
      </Box>
      <Box className="btn-conclusion" alignItems="center" display="flex">
        <Skeleton variant="text" width="100px" />
      </Box>
    </Box>
  );
};

export default Loading;
